import { useCallback } from 'react'

import { Page } from '@/components/layout/page/page.tsx'
import { Toggle } from '@/components/ui/Toggle.tsx'
import { Skeleton } from '@/components/ui/skeleton.tsx'
import { useToast } from '@/components/ui/toast.tsx'
import type { VisibilityItem } from '@/modules/creator-settings/data/visibility-items.ts'
import { visibilityItems } from '@/modules/creator-settings/data/visibility-items.ts'
import {
  useExtensionFeatureChange,
  useSettingsContext,
} from '@/modules/creator-settings/state/SettingsProvider'
import { handleError } from '@/utils/error'

import { SettingsOption } from '../SettingsOption'

export const VisibilitySiteSettings = () => {
  const settings = useSettingsContext()
  const updateFeature = useExtensionFeatureChange()

  const toast = useToast()

  const handleToggle = useCallback(
    (item: VisibilityItem) => {
      const state = !settings[item.type]

      updateFeature
        .mutateAsync({ feature: item.type, state })
        .then(() => {
          const message = item.toast[state ? 'visible' : 'hidden']

          if (message) {
            toast.success(message)
          }
        })
        .catch((error) => {
          handleError(error, 'Failed to update setting')
        })
    },
    [settings, toast, updateFeature],
  )

  return (
    <Page title="Visibility Settings">
      <hr />
      {settings.isFetching && <Skeleton className="bg-skeleton mt-8 h-80" />}
      {!settings.isFetching && (
        <div className="divide-border mt-8 grid divide-y">
          {visibilityItems.map((item, index) => {
            const checked = settings[item.type]
            const handleChange = () => handleToggle(item)

            return (
              <SettingsOption
                key={item.id}
                title={item.title}
                description={item.description}
                disableTopPadding={index === 0}
              >
                <Toggle
                  name={String(item.id)}
                  key={item.id}
                  onChange={handleChange}
                  checked={checked}
                />
              </SettingsOption>
            )
          })}
        </div>
      )}
    </Page>
  )
}
